module.exports = __webpack_public_path__ + "static/media/turnover-leftv2.e2fa044c.png";